import React from 'react';

import { LangContext } from '../components/Card/LangContext';

const withLang = <T extends { lang: string }>(
  Component: React.FunctionComponent<any>, // TODO any type
) => {
  const WithLang = (props: Omit<T, 'lang'>) => (
    <LangContext.Consumer>
      {(lang: string) => <Component lang={lang} {...props} />}
    </LangContext.Consumer>
  );

  WithLang.displayName = `WithLang(${Component.displayName || Component.name})`;

  return WithLang;
};

export default withLang;
